module.exports = __webpack_public_path__ + "img/bloom_light_natural_ba_detail_rsh_1.fb8728ee.jpg";